import React from 'react'
import { useTranslation } from 'react-i18next'

import Select from '../../../packages/kiti/components/form/Select'

export function getOperationTypeName(t) {
  return [
    { label: t('operationType.addToGeneral'), name: t('operationType.addToGeneral'), id: 'add_to_general' },
    {
      label: t('operationType.removeGeneralStock'),
      name: t('operationType.removeGeneralStock'),
      id: 'remove_general_stock'
    },
    {
      label: t('operationType.setGeneralStock'),
      name: t('operationType.setGeneralStock'),
      id: 'set_general_stock'
    },
    {
      label: t('operationType.transferFromGeneralToUser'),
      name: t('operationType.transferFromGeneralToUser'),
      id: 'transfer_from_general_to_user'
    },
    {
      label: t('operationType.transferFromUserToGeneral'),
      name: t('operationType.transferFromUserToGeneral'),
      id: 'transfer_from_user_to_general'
    },
    {
      label: t('operationType.transferFromGeneralToPlace'),
      name: t('operationType.transferFromGeneralToPlace'),
      id: 'transfer_from_general_to_place'
    },
    {
      label: t('operationType.transferFromPlaceToGeneral'),
      name: t('operationType.transferFromPlaceToGeneral'),
      id: 'transfer_from_place_to_general'
    },
    { label: t('operationType.selfUse'), name: t('operationType.selfUse'), id: 'self_use' }
  ]
}

const OperationType = ({ value, onChangeUser, index, ...props }) => {
  const { t } = useTranslation('listStocks')
  const OPERATION_TYPE_OPTIONS = getOperationTypeName(t)

  return <Select options={OPERATION_TYPE_OPTIONS} value={value} {...props} />
}

export default OperationType
